export default __webpack_public_path__ + "static/media/bunnyhead-main.f588d752.svg";